module.exports = __webpack_public_path__ + "assets/img/Sure_btn.2be50662.png";